import { Skeleton } from '@/components/ui';

export default function EventCarouselSkeleton(): React.ReactNode {
  return (
    <div className='w-full lg:h-[400px]'>
      <Skeleton
        className='h-[47vw] w-full rounded-2xl bg-gray-200 lg:h-[400px]'
        aria-label='Loading event carousel'
      />
    </div>
  );
}
